<template>
  <div>
    <div v-if="!loading">
      <NumberFormGroup
          :value="value.limit"
          name="limit"
          label="Limit"
          :error="(errors.limit || [])[0]"
          help-text="The number of items to display before the 'Load more' button appears. Clicking 'Load more' will also load this number of items."
          @input="emit('limit', $event)"
      />

      <NumberFormGroup
          :value="value.offset"
          name="offset"
          label="Offset"
          :error="(errors.offset || [])[0]"
          help-text="The number of items to skip, before getting the items to display."
          @input="emit('offset', $event)"
      />

      <NumberFormGroup
          :value="value.max"
          name="max"
          label="Max"
          :error="(errors.max || [])[0]"
          help-text="The maximum number of items to display, including 'Load more'. Max must be larger than Limit. If max is empty, an infinite amount of items can be displayed."
          @input="emit('max', $event)"
      />

      <RadioFormGroup
          :value="value.context"
          name="context"
          label="Context"
          :error="(errors.context || [])[0]"
          :options="[{value: true, label: 'Yes'}, {value: false, label: 'No'}]"
          @input="emit('context', $event)"
      />

      <TextFormGroup
          :value="value.link_url"
          name="link_url"
          label="Link URL"
          :error="(errors.link_url || [])[0]"
          @input="emit('link_url', $event)"
      />

      <TextFormGroup
          :value="value.link_text"
          name="link_text"
          label="Link Text"
          :error="(errors.link_text || [])[0]"
          @input="emit('link_text', $event)"
      />

      <SelectFormGroup
          :value="value.content_file_category_id"
          name="content_file_category_id"
          label="Content File Category"
          :error="(errors.content_file_category_id || [])[0]"
          :options="contentFileCategoryOptions"
          :nullable="true"
          help-text="A category to filter files by."
          @input="emit('content_file_category_id', $event)"
      />
    </div>
  </div>
</template>

<script>
import http from '@/http'
import store from '@/store'
import NumberFormGroup from '@/vendor/forms/FormGroups/Block/Number'
import RadioFormGroup from '@/vendor/forms/FormGroups/Block/Radio'
import SelectFormGroup from '@/vendor/forms/FormGroups/Block/Select'
import TextFormGroup from '@/vendor/forms/FormGroups/Block/Text'

export default {
  components: {NumberFormGroup, RadioFormGroup, SelectFormGroup,TextFormGroup},

  props: {
    value: {
      required: true
    },

    errors: {
      required: true
    },

    portal: {
      required: true
    }
  },

  data() {
    return {
      contentFileCategories: null,

      shared: store,
      loading: true
    }
  },

  mounted() {
    this.load()
  },

  computed: {
    contentFileCategoryOptions() {
      return this.contentFileCategories.map(contentFileCategory => {
        return {
          value: contentFileCategory.id,
          label: contentFileCategory.attributes.name
        }
      })
    }
  },

  methods: {
    emit(key, value) {
      this.$emit('input', {...this.value, [key]: value})
    },

    load() {
      http.get('/api/v2/content-file-categories', {'filter[portal_id]': this.portal.id}).then(response => {
        this.contentFileCategories = response.data.data

        this.loading = false
      })
    }
  }
}
</script>
